import { ChangeDetectionStrategy, Component, computed, Signal, signal, WritableSignal } from '@angular/core';
import { DateTimeComponent } from '@iot-platform/iot-platform-ui';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CustomDateCellParams } from '../../../models/custom-date-cell.params';

@Component({
  selector: 'grid-engine-date-cell',
  templateUrl: './date-cell.component.html',
  imports: [DateTimeComponent],
  styleUrls: ['./date-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<CustomDateCellParams> = signal(null);

  dateFormat: Signal<string> = computed(() => {
    const params = this.params();
    return params?.cellOptions?.columnFormat ?? '';
  });

  dateTimezone: Signal<string> = computed(() => {
    const params = this.params();
    if (params?.cellOptions?.columnTimezone) {
      return params.value[params.cellOptions.columnTimezone];
    }
    return null;
  });

  removeTimezone: Signal<boolean> = computed(() => {
    const params = this.params();
    return params?.cellOptions?.removeTimezone === true;
  });

  agInit(params: CustomDateCellParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
